var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn--outline console-btn btn-style",attrs:{"href":_vm.consoleLink,"title":"Console","rel":"noopener"}},[_vm._v(" Console "),_c('svg',[_c('use',_vm._b({},'use',{'xlink:href':'#home-arrow'},false))])])
}
var staticRenderFns = []

export { render, staticRenderFns }